import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { EcmRouterModule, LinkSyncPipe } from '@ecm/router';

import { CarrouselItemMobileComponent } from './components/carrousel-item-mobile/carrousel-item-mobile.component';
import { CarrouselItemRedirectLinkComponent } from './components/carrousel-item-redirect-link/carrousel-item-redirect-link.component';
import { CarrouselItemComponent } from './components/carrousel-item/carrousel-item.component';
import { CarrouselNavAccordionComponent } from './components/carrousel-nav-accordion/carrousel-nav-accordion.component';
import { CarrouselComponent } from './containers/carrousel/carrousel.component';
import { carrouselTranslation } from './i18n/fr';

@NgModule({
    declarations: [CarrouselComponent, CarrouselItemRedirectLinkComponent],
    imports: [
        CarrouselItemComponent,
        CarrouselItemMobileComponent,
        CarrouselNavAccordionComponent,
        CommonModule,
        BrowserModule,
        TranslateModule,
        RouterModule,
        EcmRouterModule,
        LinkSyncPipe,
    ],
    exports: [CarrouselComponent],
})
export class CarrouselModule {
    public constructor(translate: TranslateService) {
        translate.setTranslation('fr', carrouselTranslation, true);
    }
}
